import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IOrder } from './models/details';
import { OrderStateModel } from './models/order';
import { getPaymentMethods, fetchOrderDetails } from './operations';
import { flattenLeaves, hasId } from './utils/paymentMethods';
import { IPaymentMethods } from '../common/models/orderData';

const initialState: OrderStateModel = {
  order: {} as IOrder,
  paymentMethods: [],
  selectedId: null,
  paymentMethodsStatus: 'idle',
  paymentMethodsError: null,
};

const orderSlice = createSlice({
  name: 'OrderSlice',
  initialState,
  reducers: {
    setSelectedId(state, action: PayloadAction<number | null>) {
      state.selectedId = action.payload;
    },
  },
  extraReducers(builder) {
    builder
      // payment methods
      .addCase(getPaymentMethods.pending, (state) => {
        state.paymentMethodsStatus = 'loading';
        state.paymentMethodsError = null;
      })
      .addCase(
        getPaymentMethods.fulfilled,
        (state, action: PayloadAction<IPaymentMethods[]>) => {
          state.paymentMethods = action.payload;
          state.paymentMethodsStatus = 'succeeded';

          if (state.selectedId == null) {
            const firstLeaf = flattenLeaves(state.paymentMethods).find(hasId);
            state.selectedId = firstLeaf?.id ?? null;
          }
        }
      )
      .addCase(getPaymentMethods.rejected, (state, action) => {
        state.paymentMethodsStatus = 'failed';
        state.paymentMethodsError =
          (action.error?.message as string) ?? 'Failed to load payment methods';
      })

      .addCase(fetchOrderDetails.pending, () => {
        // opcjonalnie: możesz wyczyścić poprzednie
        // state.order = null;
      })
      .addCase(
        fetchOrderDetails.fulfilled,
        (state, action: PayloadAction<IOrder>) => {
          state.order = action.payload;
        }
      )
      .addCase(fetchOrderDetails.rejected, () => {
        // opcjonalnie: state.order = null;
      });
  },
});

export const { setSelectedId } = orderSlice.actions;
export default orderSlice.reducer;
